<template>
  <router-view />
</template>
<script>
export default {
  name: "memberCenter",
  data() {
    return {};
  }
};
</script>
<style lang="less" scoped>
.memberCenter {
  position: relative;
}
</style>
